import { useParams } from "react-router-dom";
import useAssessment from "./useAssessment";
import useAssessmentPreview from "./useAssessmentPreview";

const useAssessmentPage = () => {
  const { assessmentId } = useParams();
  const assessment = useAssessment({ id: assessmentId });
  const { title, articles } = useAssessmentPreview({ assessmentId });

  const page = {
    hasAccess: assessment?.hasAccess,
    header: {
      title,
      carriedOutBy: {
        ...assessment?.data?.user,
        date: assessment?.data?.date_created,
      },
    },
    articles,
  };

  return page;
};

export default useAssessmentPage;
